
import {Header, Hero, About, Experience, Skills, Projects, ContactMe} from './components'
import img from './assets/me/headerImg.png'
export default function App() {
  return (
    <div className='bg-[rgb(36,36,36)] text-white h-screen snap-y snap-mandatory overflow-y-scroll z-0 overflow-x-hidden scrollbar-thin scrollbar-thumb-[#F7AB0A]/80 scrollbar-track-gray-400/20'>
    <Header/>

    <section id="hero" className='snap-start'>
      <Hero/>
    </section>

    <section id="about" className="snap-center">
      <About/>
    </section>

    <section id="experience" className='snap-center'>
      <Experience/>
    </section>

    <section id="skills" className='snap-start'>
      <Skills/>
    </section>

    <section id="projects" className='snap-start'>
      <Projects/>
    </section>

    <section id="contactme" className='snap-end'>
      <ContactMe/>
    </section>

    <a href="#hero">
      <footer className='sticky bottom-5 w-full cursor-pointer'>
        <div className='flex items-center justify-center'>
          <img className='h-5 2-5 rounded-full filter grayscale hover:grayscale-0 cursor-pointer'
          src={img}
          alt=''/>
        </div>
      </footer>
    </a>
    </div>
  )
}
